var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckAccent = function SvgIconCheckAccent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D83EA",
    strokeWidth: 1.5,
    d: "m8 15.312 4.782 4.782L22.876 10",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  })));
};
export default SvgIconCheckAccent;